import styled from "styled-components";
import FormButton from "../../components/FormCustom2/Button";
import { Form } from "antd";

export const CellRowImage = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  & span {
    color: #707070;
    margin-left: 17px;
    font-weight: 600;
    font-size: 15px;
    color: #000000;
    @media screen and (max-width: 1024px) {
      & {
        font-size: 14px;
      }
    }
  }
  &.v2 span {
    color: #707070;
    margin-left: 8px;
    font-weight: 600;
    font-size: 16px;
    color: #000000;
    @media screen and (max-width: 1024px) {
      & {
        font-size: 14px;
      }
    }
  }
`;
export const CellRowValue = styled.div`
  & p {
    margin-bottom: 4px;
  }

  & span.highlight {
    font-weight: 700;
    font-size: 16px;
    color: #F12E11;
  }

  & span {
    font-size: 16px;
    display: flex;
    align-items: center;
    padding-left: 0px;
    white-space: nowrap;

    & svg {
      height: 8px;
      margin-left: -4px;
    }

    @media screen and (max-width: 1024px) {
      & {
        font-size: 14px;
      }
    }
  }
`;

export const ButtonCreateWallet = styled(FormButton)`
  
  height: 52px;
  &.primary2{
    min-width: 212px !important;
  }
  @media screen and (max-width: 1024px) {
    width: 330px !important;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.25) !important;
  }
`;

export const BalanceContainer = styled.div`
  margin-bottom: 64px;
  position: relative;

  @media screen and (max-width: 1024px) {
    & {
      margin-bottom: 33px;
    }
  }
`;
export const BalanceTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  @media screen and (max-width: 1024px) {
    & {
      margin-bottom: 16px;
    }
  }
`;
export const BalanceText = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #000000;
  @media screen and (max-width: 1024px) {
    & {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const BalanceIcon = styled.div`
  margin-left: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  top: 2px;
  @media screen and (max-width: 1024px) {
    & {
      width: 20px;
      margin-left: 12px;
    }
  }
`;

export const SubBalanceIcon = styled.div`
  margin-left: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  top: 24px;
  @media screen and (max-width: 1024px) {
    & {
      width: 20px;
      margin-left: 12px;
      top: 20px;
    }
  }
`;

export const BalanceValue = styled.div`
  display: flex;
  align-items: center;
`;
export const BalanceValueBTC = styled.div`
  font-weight: 600;
  font-size: 34px;
  white-space: nowrap;
  background: #F12E11;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  @media screen and (max-width: 1024px) {
    & {
      flex: 1 0 100%;
      font-size: 26px;
    }
  }
`;

export const BalanceValueBTC2 = styled.div`
  font-weight: 600;
  font-size: 34px;
  white-space: nowrap;
  color: #616161;
  @media screen and (max-width: 1024px) {
    & {
      flex: 1 0 100%;
      font-size: 26px;
    }
  }
`;

export const BalanceValueIcon = styled.div`
  margin: 0 24px;
  @media screen and (max-width: 1024px) {
    & {
      margin: 0 6px;
    }
    & svg {
      width: 16px;
    }
  }
`;
export const BalanceValueEqual = styled.div`
  font-weight: 600;
  font-size: 34px;
  background: #F12E11;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  @media screen and (max-width: 1024px) {
    & {
      font-size: 26px;
    }
  }
`;

export const EmptyContainer = styled.div`
  margin-top: 66px;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & > div {
    position: inherit;
  }

  & h1 {
    font-weight: 400;
    font-size: 20px;
    line-height: 25px;
    display: flex;
    align-items: flex-end;
    text-align: center;
    color: #000000;
    margin-top: 27px;
    margin-bottom: 58px;
  }

  @media screen and (max-width: 1024px) {
    & {
    }
  }
`;

export const CreateContainer = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1;

  @media screen and (max-width: 1024px) {
    & {
      position: fixed;
      z-index: 3;
      width: 100%;
      height: auto;
      bottom: 20px;
      left: 0;
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    & button {
      width: 275px;
      height: 50px;
      font-size: 16px;
      box-shadow: 0px -10px 5px #f5f5f5, 0px -1px 10px #f5f5f5,
        0px -2px 15px #f5f5f5, 0px -3px 20px #f5f5f5, 0px -4px 25px #f5f5f5,
        0px -5px 30px #f5f5f5, 0px -6px 8px #f5f5f5, 0px -7px 6px #f5f5f5,
        0px -8px 9px #f5f5f5, 0px 10px 5px #f5f5f5, 0px 1px 10px #f5f5f5,
        0px 2px 15px #f5f5f5, 0px 3px 20px #f5f5f5, 0px 4px 25px #f5f5f5,
        0px 5px 30px #f5f5f5, 0px 6px 8px #f5f5f5, 0px 7px 6px #f5f5f5,
        0px 8px 9px #f5f5f5;

      border-radius: 10px;
    }
  }
`;

export const EyeIcon = ({ width = 22, height = 16 }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5034 12.3074C11.5214 12.3074 12.3495 11.4793 12.3495 10.4613C12.3495 9.44331 11.5214 8.61523 10.5034 8.61523C9.48542 8.61523 8.65735 9.44331 8.65735 10.4613C8.65735 11.4793 9.48542 12.3074 10.5034 12.3074ZM10.5034 9.84589C10.8428 9.84589 11.1189 10.122 11.1189 10.4613C11.1189 10.8007 10.8428 11.0768 10.5034 11.0768C10.1641 11.0768 9.888 10.8007 9.888 10.4613C9.888 10.122 10.1641 9.84589 10.5034 9.84589Z"
      fill="black"
    />
    <path
      d="M3.26416 13.4255C5.64898 15.1096 8.15219 15.9998 10.5034 15.9998C12.8547 15.9998 15.3579 15.1096 17.7427 13.4255C19.5266 12.1657 20.6138 10.9163 20.6594 10.8635L21.0069 10.4613L20.6594 10.0592C20.6141 10.0066 19.5266 8.75693 17.7427 7.49718C15.3579 5.81307 12.8547 4.92285 10.5034 4.92285C8.15219 4.92285 5.64898 5.81307 3.26416 7.49718C1.48027 8.75693 0.393003 10.0066 0.347488 10.0592L0 10.4613L0.347488 10.8635C0.392784 10.9163 1.48027 12.1657 3.26416 13.4255ZM17.0074 8.48444C18.0861 9.24326 18.9028 10.0107 19.3484 10.4613C18.9028 10.9122 18.0861 11.6794 17.0074 12.4382C16.4607 12.8226 15.8034 13.2336 15.0628 13.6017C15.6799 12.7087 16.0419 11.6266 16.0419 10.4613C16.0419 9.29605 15.6799 8.21393 15.0628 7.32092C15.8034 7.68908 16.4607 8.10003 17.0074 8.48444ZM10.5034 6.15372C12.8767 6.15372 14.811 8.08422 14.811 10.4613C14.811 12.8348 12.8803 14.7689 10.5034 14.7689C8.13014 14.7689 6.19582 12.8384 6.19582 10.4613C6.19582 8.08613 8.12823 6.15372 10.5034 6.15372ZM5.94516 7.31938C5.32737 8.21289 4.96495 9.29545 4.96495 10.4613C4.96495 11.6266 5.32693 12.7087 5.94406 13.6017C5.20341 13.2336 4.54612 12.8226 3.99945 12.4382C2.92099 11.6794 2.10402 10.9122 1.65867 10.4615C2.08329 10.0324 2.84659 9.31596 3.85716 8.58915C4.46915 8.14915 5.17179 7.70533 5.94516 7.31938Z"
      fill="black"
    />
    <path d="M11.1188 0H9.88794V3.07696H11.1188V0Z" fill="black" />
    <path
      d="M13.6406 3.42163L14.8708 0.961426L15.9711 1.51149L14.7409 3.97192L13.6406 3.42163Z"
      fill="black"
    />
    <path
      d="M17.3956 5.78476L19.2419 3.32324L20.2264 4.06155L18.3803 6.52329L17.3956 5.78476Z"
      fill="black"
    />
    <path
      d="M5.02673 1.50579L6.12702 0.955566L7.35724 3.41599L6.25695 3.96606L5.02673 1.50579Z"
      fill="black"
    />
    <path
      d="M0.780396 4.06176L1.76487 3.32324L3.61118 5.78476L2.62648 6.52329L0.780396 4.06176Z"
      fill="black"
    />
  </svg>
);
export const NoEyeIcon = ({ width = 20, height = 12 }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.387532 0.101582C0.75612 -0.10925 1.22586 0.0186976 1.43669 0.387285L1.44073 0.39408C1.44496 0.401067 1.45195 0.413054 1.46201 0.429336C1.48201 0.462413 1.51381 0.513502 1.5574 0.580104C1.64451 0.713565 1.77797 0.908371 1.95804 1.14452C2.31835 1.61773 2.86098 2.25048 3.58335 2.88278C5.0284 4.147 7.16332 5.38475 9.99984 5.38475C12.8366 5.38475 14.9713 4.147 16.4163 2.88278C17.1387 2.25048 17.6813 1.61773 18.0419 1.14452C18.2217 0.908371 18.3552 0.713565 18.4423 0.580104C18.4859 0.513502 18.5177 0.462413 18.5377 0.429336C18.5477 0.413054 18.5547 0.401067 18.559 0.39408L18.5627 0.387798L18.5632 0.386516C18.7746 0.0186976 19.2438 -0.108994 19.6122 0.101582C19.981 0.312414 20.1092 0.782154 19.8984 1.151L19.2306 0.769398C19.8984 1.151 19.8986 1.15074 19.8984 1.151L19.8976 1.15254L19.8936 1.15952L19.8841 1.17555C19.8763 1.18882 19.8653 1.20734 19.8513 1.23016C19.8232 1.27619 19.7829 1.3408 19.7304 1.42144C19.6252 1.58247 19.4702 1.8083 19.2654 2.07695C18.8567 2.61336 18.2455 3.32675 17.4294 4.04059C15.7976 5.46866 13.3171 6.9232 9.99984 6.9232C6.68281 6.9232 4.20212 5.46866 2.57027 4.04059C1.75419 3.32675 1.14298 2.61336 0.734069 2.07695C0.529519 1.8083 0.37452 1.58247 0.269328 1.42144C0.216764 1.3408 0.176444 1.27619 0.148367 1.23016C0.134393 1.20734 0.123367 1.18882 0.115611 1.17555L0.10606 1.15952L0.102086 1.15254L0.101573 1.15151C0.101316 1.15125 0.101316 1.151 0.769133 0.769398L0.101573 1.15151C-0.109259 0.782667 0.0186887 0.312414 0.387532 0.101582Z"
      fill="black"
    />
    <path
      d="M2.85152 6.69783L1.31307 8.23628C1.01288 8.5368 0.525574 8.5368 0.225383 8.23628C-0.0751277 7.93609 -0.0751277 7.44879 0.225383 7.1486L1.76383 5.61015C2.06403 5.30964 2.55133 5.30964 2.85152 5.61015C3.15203 5.91034 3.15203 6.39764 2.85152 6.69783Z"
      fill="black"
    />
    <path
      d="M18.6867 8.23628L17.1482 6.69783C16.8477 6.39764 16.8477 5.91034 17.1482 5.61015C17.4484 5.30964 17.9357 5.30964 18.2359 5.61015L19.7744 7.1486C20.0749 7.44879 20.0749 7.93609 19.7744 8.23628C19.4742 8.5368 18.9869 8.5368 18.6867 8.23628Z"
      fill="black"
    />
    <path
      d="M5.714 10.2867C5.55625 10.6811 5.10849 10.8729 4.71414 10.7152C4.31978 10.5574 4.12792 10.1097 4.28568 9.71533L5.05491 7.79226C5.21266 7.39791 5.66016 7.20605 6.05477 7.3638C6.44913 7.52156 6.64098 7.96931 6.48323 8.36367L5.714 10.2867Z"
      fill="black"
    />
    <path
      d="M15.2852 10.7152C14.8909 10.8729 14.4431 10.6811 14.2854 10.2867L13.5161 8.36367C13.3584 7.96931 13.5503 7.52156 13.9446 7.3638C14.3392 7.20605 14.7867 7.39791 14.9445 7.79226L15.7137 9.71533C15.8715 10.1097 15.6796 10.5574 15.2852 10.7152Z"
      fill="black"
    />
    <path
      d="M10.7689 10.7704C10.7689 11.1953 10.4246 11.5396 9.99969 11.5396C9.57476 11.5396 9.23047 11.1953 9.23047 10.7704V8.84735C9.23047 8.42242 9.57476 8.07812 9.99969 8.07812C10.4246 8.07812 10.7689 8.42242 10.7689 8.84735V10.7704Z"
      fill="black"
    />
  </svg>
);
export const EqualIcon = () => (
  <svg
    width="9"
    height="6"
    viewBox="0 0 9 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_18814_7405)">
      <path
        d="M6.61763 2.00014C5.79701 1.99258 4.98999 1.80252 4.26178 1.44508C3.08791 0.850488 1.67677 0.850488 0.502894 1.44508L0.0264893 0.555207C1.49941 -0.184418 3.26527 -0.184418 4.73819 0.555207C5.91206 1.1498 7.32321 1.1498 8.49708 0.555207L8.97348 1.44508C8.24528 1.80252 7.43825 1.99258 6.61763 2.00014Z"
        fill="black"
      />
      <path
        d="M6.61763 6.00014C5.79701 5.99258 4.98999 5.80252 4.26178 5.44508C3.08791 4.85049 1.67677 4.85049 0.502894 5.44508L0.0264893 4.55521C1.49941 3.81558 3.26527 3.81558 4.73819 4.55521C5.91206 5.1498 7.32321 5.1498 8.49708 4.55521L8.97348 5.44508C8.24528 5.80252 7.43825 5.99258 6.61763 6.00014Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_18814_7405">
        <rect width="9" height="6" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const EqualIcon3 = () => (
  <svg
    width="20"
    height="13"
    viewBox="0 0 20 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_19201_20005)">
      <path
        d="M14.7058 4.33356C12.8822 4.31718 11.0888 3.90538 9.4706 3.13093C6.862 1.84264 3.72612 1.84264 1.11751 3.13093L0.0588379 1.20287C3.332 -0.399654 7.25612 -0.399654 10.5293 1.20287C13.1379 2.49115 16.2738 2.49115 18.8824 1.20287L19.941 3.13093C18.3228 3.90538 16.5294 4.31718 14.7058 4.33356Z"
        fill="black"
      />
      <path
        d="M14.7058 13.0001C12.8822 12.9837 11.0888 12.5719 9.4706 11.7974C6.862 10.5091 3.72612 10.5091 1.11751 11.7974L0.0588379 9.86937C3.332 8.26685 7.25612 8.26685 10.5293 9.86937C13.1379 11.1577 16.2738 11.1577 18.8824 9.86937L19.941 11.7974C18.3228 12.5719 16.5294 12.9837 14.7058 13.0001Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_19201_20005">
        <rect width="20" height="13" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const EqualIcon2 = () => (
  <svg
    width="9"
    height="6"
    viewBox="0 0 9 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_786_32686)">
      <path
        d="M6.61776 2.00014C5.79713 1.99258 4.99011 1.80252 4.26191 1.44508C3.08803 0.850488 1.67689 0.850488 0.503016 1.44508L0.0266113 0.555207C1.49953 -0.184418 3.26539 -0.184418 4.73831 0.555207C5.91218 1.1498 7.32333 1.1498 8.4972 0.555207L8.9736 1.44508C8.2454 1.80252 7.43838 1.99258 6.61776 2.00014Z"
        fill="#818181"
      />
      <path
        d="M6.61776 6.00014C5.79713 5.99258 4.99011 5.80252 4.26191 5.44508C3.08803 4.85049 1.67689 4.85049 0.503016 5.44508L0.0266113 4.55521C1.49953 3.81558 3.26539 3.81558 4.73831 4.55521C5.91218 5.1498 7.32333 5.1498 8.4972 4.55521L8.9736 5.44508C8.2454 5.80252 7.43838 5.99258 6.61776 6.00014Z"
        fill="#818181"
      />
    </g>
    <defs>
      <clipPath id="clip0_786_32686">
        <rect width="9" height="6" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const EmptyIcon = (props) => (
  <svg
    width="195"
    height="150"
    viewBox="0 0 195 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.62">
      <g clipPath="url(#clip0_772_32082)">
        <path
          d="M194.72 69.8473C194.72 65.4275 191.124 61.8321 186.703 61.8321H184.412V35.4962C184.412 31.0763 180.815 27.4809 176.394 27.4809H167.231V8.01527C167.231 3.59542 163.634 0 159.213 0H14.8904C6.68006 0 0 6.67786 0 14.8855V135.115C0 143.323 6.68006 150 14.8904 150H176.394C180.815 150 184.412 146.405 184.412 141.985V112.214H186.703C191.124 112.214 194.72 108.618 194.72 104.198V69.8473Z"
          fill="url(#paint0_linear_772_32082)"
        />
        <path
          d="M14.8906 2.29004H159.213C162.371 2.29004 164.94 4.85836 164.94 8.01523V27.4809H14.8906C7.94306 27.4809 2.29102 21.8307 2.29102 14.8855C2.29102 7.94023 7.94306 2.29004 14.8906 2.29004Z"
          fill="#F5F5F5"
        />
        <path
          d="M182.121 141.985C182.121 145.142 179.552 147.71 176.394 147.71H14.8906C7.94306 147.71 2.29102 142.06 2.29102 135.114V23.9404L5.95692 26.6914C8.64234 28.7061 11.7315 29.771 14.8906 29.771H176.394C179.552 29.771 182.121 32.3393 182.121 35.4962V61.832H166.085C157.875 61.832 151.195 68.5099 151.195 76.7175V97.3282C151.195 105.536 157.875 112.214 166.085 112.214H182.121V141.985Z"
          fill="#F5F5F5"
        />
        <path
          d="M192.429 104.198C192.429 107.355 189.86 109.924 186.702 109.924H166.085C159.137 109.924 153.485 104.273 153.485 97.3282V76.7175C153.485 69.7723 159.137 64.1221 166.085 64.1221H186.702C189.86 64.1221 192.429 66.6904 192.429 69.8473V104.198Z"
          fill="#F5F5F5"
        />
        <path
          d="M56.2998 84.6107C56.6939 84.8157 57.2815 84.7716 57.7121 84.3645C58.1124 83.9632 58.1021 83.2372 57.6669 82.8021L49.1748 74.3134L57.6675 65.8241C58.1096 65.3815 58.1096 64.6607 57.6669 64.2176C57.2545 63.8054 56.4745 63.8059 56.0616 64.2181L47.5689 72.708L39.0768 64.2181C38.6799 63.822 37.8701 63.822 37.4732 64.2181C37.259 64.4323 37.1411 64.7174 37.1411 65.0214C37.1411 65.3254 37.259 65.6099 37.4727 65.8241L45.9653 74.3134L37.4727 82.8027C37.0299 83.2452 37.0299 83.9655 37.4727 84.4086C37.6943 84.6302 37.9543 84.7326 38.2911 84.7326C38.6078 84.7326 38.8993 84.609 39.1564 84.3651L47.6044 75.9187L56.2998 84.6107Z"
          fill="url(#paint1_linear_772_32082)"
        />
        <path
          d="M114.476 84.3725C114.7 84.5952 114.961 84.6989 115.297 84.6989C115.611 84.6989 115.901 84.5752 116.157 84.3319C116.336 84.1521 116.452 83.867 116.452 83.5693C116.452 83.2676 116.332 82.983 116.117 82.7672L107.623 74.2767L116.116 65.7874C116.336 65.5681 116.452 65.2911 116.452 64.9859C116.452 64.7981 116.406 64.6161 116.318 64.454L116.049 64.1844C115.652 63.7882 114.841 63.7882 114.443 64.1844L105.95 72.6743L97.4583 64.1844C97.0379 63.7647 96.2722 63.7647 95.8524 64.1844C95.6371 64.3996 95.5186 64.6848 95.5186 64.9859C95.5186 65.2876 95.6371 65.5722 95.8524 65.7874L104.345 74.2767L95.8524 82.7661C95.4097 83.2086 95.4097 83.9294 95.8524 84.372C96.0752 84.5952 96.3364 84.6983 96.6737 84.6983C96.9881 84.6983 97.2773 84.5746 97.5339 84.3307L105.985 75.8815L114.476 84.3725Z"
          fill="url(#paint2_linear_772_32082)"
        />
        <path
          d="M172.957 79.0078C168.536 79.0078 164.939 82.6032 164.939 87.0231C164.939 91.4429 168.536 95.0383 172.957 95.0383C177.379 95.0383 180.975 91.4429 180.975 87.0231C180.975 82.6032 177.379 79.0078 172.957 79.0078ZM172.957 92.7483C169.799 92.7483 167.23 90.18 167.23 87.0231C167.23 83.8662 169.799 81.2979 172.957 81.2979C176.115 81.2979 178.684 83.8662 178.684 87.0231C178.684 90.18 176.115 92.7483 172.957 92.7483Z"
          fill="url(#paint3_linear_772_32082)"
        />
        <path
          d="M76.7261 108.016C83.3054 108.016 90.0129 110.516 96.6621 115.447C96.8723 115.598 97.1174 115.683 97.3602 115.683C97.7353 115.683 98.0555 115.528 98.2616 115.247C98.4569 114.986 98.5325 114.692 98.4873 114.388C98.4415 114.082 98.2845 113.823 98.0337 113.638C83.8775 103.137 69.5455 103.135 55.4294 113.628L55.2485 113.762C54.8957 114.171 54.8607 114.772 55.1752 115.191C55.5623 115.707 56.2816 115.825 56.7782 115.453C63.4359 110.517 70.1457 108.016 76.7261 108.016Z"
          fill="url(#paint4_linear_772_32082)"
        />
        <path
          d="M23.3085 16.0303H146.499C147.131 16.0303 147.644 15.5168 147.644 14.8853C147.644 14.2538 147.131 13.7402 146.499 13.7402H23.3085C22.6768 13.7402 22.1631 14.2538 22.1631 14.8853C22.1631 15.5168 22.6768 16.0303 23.3085 16.0303Z"
          fill="url(#paint5_linear_772_32082)"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_772_32082"
        x1="0"
        y1="75.0051"
        x2="194.731"
        y2="75.0051"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#000"/>
        <stop offset="1" stopColor="#000"/>
      </linearGradient>
      <linearGradient
        id="paint1_linear_772_32082"
        x1="37.1406"
        y1="74.3214"
        x2="58.0043"
        y2="74.3214"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#000"/>
        <stop offset="1" stopColor="#000"/>
      </linearGradient>
      <linearGradient
        id="paint2_linear_772_32082"
        x1="95.5186"
        y1="74.285"
        x2="116.453"
        y2="74.285"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#000"/>
        <stop offset="1" stopColor="#000"/>
      </linearGradient>
      <linearGradient
        id="paint3_linear_772_32082"
        x1="164.939"
        y1="87.0236"
        x2="180.976"
        y2="87.0236"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#000"/>
        <stop offset="1" stopColor="#000"/>
      </linearGradient>
      <linearGradient
        id="paint4_linear_772_32082"
        x1="54.96"
        y1="110.722"
        x2="98.5023"
        y2="110.722"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#000"/>
        <stop offset="1" stopColor="#000"/>
      </linearGradient>
      <linearGradient
        id="paint5_linear_772_32082"
        x1="22.1631"
        y1="14.8854"
        x2="147.651"
        y2="14.8854"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#000"/>
        <stop offset="1" stopColor="#000"/>
      </linearGradient>
      <clipPath id="clip0_772_32082">
        <rect width="194.72" height="150" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IconHideAmount = ({ width = 190 }) => (
  <svg
    width={width}
    height="20"
    viewBox="0 0 190 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_772_30426)">
      <path
        d="M17.503 4.98127C17.0177 4.13811 15.9191 3.85748 15.076 4.34275L10.6325 6.92173V1.78868C10.6325 0.81845 9.84076 0.0263672 8.87053 0.0263672C7.90031 0.0263672 7.10822 0.81845 7.10822 1.78868V6.92173L2.66381 4.34275C1.82065 3.85748 0.723036 4.13811 0.238081 4.98127C-0.24847 5.82444 0.0334356 6.92173 0.8766 7.407L5.34623 10.0122L0.8766 12.6173C0.0334356 13.1023 -0.24847 14.2012 0.238081 15.044C0.723036 15.8872 1.82065 16.1678 2.66381 15.6825L7.10822 13.1023V18.2366C7.10822 19.2071 7.90031 19.9989 8.87053 19.9989C9.84076 19.9989 10.6325 19.2071 10.6325 18.2366V13.1023L15.076 15.6825C15.9191 16.1678 17.0177 15.8872 17.503 15.044C17.9883 14.2012 17.7076 13.1023 16.8645 12.6173L12.3948 10.0122L16.8645 7.407C17.7076 6.89683 18.0144 5.82444 17.503 4.98127Z"
        fill="url(#paint0_linear_772_30426)"
      />
      <path
        d="M23.8228 15.0176C24.3081 15.8608 25.4054 16.1427 26.2486 15.6562L30.6933 13.0772V18.2102C30.6933 19.1817 31.485 19.9738 32.4553 19.9738C33.4255 19.9738 34.2176 19.1817 34.2176 18.2102V13.0772L38.6623 15.6562C39.5039 16.1427 40.6028 15.8608 41.0877 15.0176C41.573 14.1761 41.2924 13.0772 40.4492 12.5922L35.9796 9.98707L40.4492 7.38159C41.2924 6.89664 41.573 5.79807 41.0877 4.9549C40.6028 4.11174 39.5039 3.83111 38.6623 4.31639L34.2176 6.89664V1.76231C34.2176 0.792082 33.4255 0 32.4553 0C31.485 0 30.6933 0.792082 30.6933 1.76231V6.89664L26.2486 4.34257C25.4054 3.85729 24.3081 4.13792 23.8228 4.98108C23.3379 5.82425 23.6182 6.92154 24.4613 7.40682L28.931 10.012L24.4613 12.5922C23.6182 13.0772 23.3379 14.1761 23.8228 15.0176Z"
        fill="url(#paint1_linear_772_30426)"
      />
      <path
        d="M47.3957 15.0176C47.8823 15.8608 48.9796 16.1427 49.8227 15.6562L54.2675 13.0772V18.2102C54.2675 19.1817 55.0579 19.9738 56.0294 19.9738C56.9997 19.9738 57.7918 19.1817 57.7918 18.2102V13.0772L62.2352 15.6562C63.0781 16.1427 64.1769 15.8608 64.6619 15.0176C65.1472 14.1761 64.8665 13.0772 64.0234 12.5922L59.5537 9.98707L64.0234 7.38159C64.8665 6.89664 65.1472 5.79807 64.6619 4.9549C64.1769 4.11174 63.0781 3.83111 62.2352 4.31639L57.7918 6.89664V1.76231C57.7918 0.792082 56.9997 0 56.0294 0C55.0579 0 54.2675 0.792082 54.2675 1.76231V6.89664L49.8227 4.31639C48.9796 3.83111 47.8823 4.11174 47.3957 4.9549C46.9108 5.79807 47.1927 6.89664 48.0342 7.38159L52.5039 9.98707L48.0342 12.5922C47.1927 13.0772 46.9108 14.1761 47.3957 15.0176Z"
        fill="url(#paint2_linear_772_30426)"
      />
      <path
        d="M70.9814 15.0176C71.4666 15.8608 72.5639 16.1427 73.4071 15.6562L77.8518 13.0772V18.2102C77.8518 19.1817 78.6436 19.9738 79.6138 19.9738C80.5843 19.9738 81.3761 19.1817 81.3761 18.2102V13.0772L85.8208 15.6562C86.6627 16.1427 87.7613 15.8608 88.2466 15.0176C88.7315 14.1761 88.4509 13.0772 87.6081 12.5922L83.1384 9.98707L87.6081 7.38159C88.4509 6.89664 88.7315 5.79807 88.2466 4.9549C87.7613 4.11174 86.6627 3.83111 85.8208 4.31639L81.3761 6.89664V1.76231C81.3761 0.792082 80.5843 0 79.6138 0C78.6436 0 77.8518 0.792082 77.8518 1.76231V6.89664L73.4071 4.31639C72.5639 3.83111 71.4666 4.11174 70.9814 4.9549C70.4964 5.79807 70.777 6.89664 71.6199 7.38159L76.0895 9.98707L71.6199 12.5922C70.777 13.0772 70.4702 14.1761 70.9814 15.0176Z"
        fill="url(#paint3_linear_772_30426)"
      />
      <path
        d="M94.5548 15.0308C95.04 15.874 96.1373 16.1559 96.9805 15.6693L101.425 13.0904V18.2234C101.425 19.1949 102.217 19.987 103.187 19.987C104.157 19.987 104.95 19.1949 104.95 18.2234V13.0904L109.394 15.6693C110.236 16.1559 111.335 15.874 111.82 15.0308C112.305 14.1893 112.024 13.0904 111.181 12.6054L106.712 10.0003L111.181 7.39478C112.024 6.90982 112.305 5.81125 111.82 4.96809C111.335 4.12492 110.236 3.8443 109.394 4.32957L104.95 6.90982V1.7755C104.95 0.805266 104.157 0.0131836 103.187 0.0131836C102.217 0.0131836 101.425 0.805266 101.425 1.7755V6.90982L96.9805 4.35575C96.1373 3.87047 95.04 4.1511 94.5548 4.99427C94.0698 5.83743 94.3501 6.93473 95.1933 7.42L99.6629 10.0252L95.1933 12.6054C94.3501 13.0904 94.0698 14.1893 94.5548 15.0308Z"
        fill="url(#paint4_linear_772_30426)"
      />
      <path
        d="M118.128 15.0308C118.614 15.874 119.711 16.1559 120.555 15.6693L124.999 13.0904V18.2234C124.999 19.1949 125.79 19.987 126.761 19.987C127.732 19.987 128.524 19.1949 128.524 18.2234V13.0904L132.967 15.6693C133.81 16.1559 134.909 15.874 135.394 15.0308C135.879 14.1893 135.598 13.0904 134.755 12.6054L130.286 10.0003L134.755 7.39478C135.598 6.90982 135.879 5.81125 135.394 4.96809C134.909 4.12492 133.81 3.8443 132.967 4.32957L128.524 6.90982V1.7755C128.524 0.805266 127.732 0.0131836 126.761 0.0131836C125.79 0.0131836 124.999 0.805266 124.999 1.7755V6.90982L120.555 4.32957C119.711 3.8443 118.614 4.12492 118.128 4.96809C117.643 5.81125 117.925 6.90982 118.766 7.39478L123.236 10.0003L118.766 12.6054C117.925 13.0904 117.643 14.1893 118.128 15.0308Z"
        fill="url(#paint5_linear_772_30426)"
      />
      <path
        d="M141.714 15.0308C142.199 15.874 143.296 16.1559 144.14 15.6693L148.584 13.0904V18.2234C148.584 19.1949 149.376 19.987 150.346 19.987C151.317 19.987 152.109 19.1949 152.109 18.2234V13.0904L156.553 15.6693C157.395 16.1559 158.494 15.874 158.979 15.0308C159.464 14.1893 159.183 13.0904 158.34 12.6054L153.871 10.0003L158.34 7.39478C159.183 6.90982 159.464 5.81125 158.979 4.96809C158.494 4.12492 157.395 3.8443 156.553 4.32957L152.109 6.90982V1.7755C152.109 0.805266 151.317 0.0131836 150.346 0.0131836C149.376 0.0131836 148.584 0.805266 148.584 1.7755V6.90982L144.14 4.32957C143.296 3.8443 142.199 4.12492 141.714 4.96809C141.229 5.81125 141.509 6.90982 142.352 7.39478L146.822 10.0003L142.352 12.6054C141.509 13.0904 141.203 14.1893 141.714 15.0308Z"
        fill="url(#paint6_linear_772_30426)"
      />
      <path
        d="M165.287 15.044C165.772 15.8872 166.869 16.1691 167.712 15.6825L172.157 13.1035V18.2366C172.157 19.2081 172.949 20.0002 173.919 20.0002C174.889 20.0002 175.681 19.2081 175.681 18.2366V13.1035L180.126 15.6825C180.968 16.1691 182.067 15.8872 182.552 15.044C183.037 14.2024 182.756 13.1035 181.913 12.6186L177.443 10.0134L181.913 7.40796C182.756 6.92301 183.037 5.82444 182.552 4.98127C182.067 4.13811 180.968 3.85748 180.126 4.34275L175.681 6.92301V1.78868C175.681 0.81845 174.889 0.0263672 173.919 0.0263672C172.949 0.0263672 172.157 0.81845 172.157 1.78868V6.92301L167.712 4.36893C166.869 3.88366 165.772 4.16429 165.287 5.00745C164.802 5.85061 165.082 6.94791 165.925 7.43318L170.395 10.0383L165.925 12.6186C165.082 13.1035 164.802 14.2024 165.287 15.044Z"
        fill="url(#paint7_linear_772_30426)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_772_30426"
        x1="0"
        y1="10.0133"
        x2="17.7531"
        y2="10.0133"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#000"/>
        <stop offset="1" stopColor="#000"/>
      </linearGradient>
      <linearGradient
        id="paint1_linear_772_30426"
        x1="23.5854"
        y1="9.98759"
        x2="41.3262"
        y2="9.98759"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#000"/>
        <stop offset="1" stopColor="#000"/>
      </linearGradient>
      <linearGradient
        id="paint2_linear_772_30426"
        x1="47.1587"
        y1="9.98759"
        x2="64.9003"
        y2="9.98759"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#000"/>
        <stop offset="1" stopColor="#000"/>
      </linearGradient>
      <linearGradient
        id="paint3_linear_772_30426"
        x1="70.7324"
        y1="9.98759"
        x2="88.4848"
        y2="9.98759"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#000"/>
        <stop offset="1" stopColor="#000"/>
      </linearGradient>
      <linearGradient
        id="paint4_linear_772_30426"
        x1="94.3174"
        y1="10.0008"
        x2="112.058"
        y2="10.0008"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#000"/>
        <stop offset="1" stopColor="#000"/>
      </linearGradient>
      <linearGradient
        id="paint5_linear_772_30426"
        x1="117.891"
        y1="10.0008"
        x2="135.632"
        y2="10.0008"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#000"/>
        <stop offset="1" stopColor="#000"/>
      </linearGradient>
      <linearGradient
        id="paint6_linear_772_30426"
        x1="141.465"
        y1="10.0008"
        x2="159.217"
        y2="10.0008"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#000"/>
        <stop offset="1" stopColor="#000"/>
      </linearGradient>
      <linearGradient
        id="paint7_linear_772_30426"
        x1="165.049"
        y1="10.014"
        x2="182.79"
        y2="10.014"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#000"/>
        <stop offset="1" stopColor="#000"/>
      </linearGradient>
      <clipPath id="clip0_772_30426">
        <rect width="320.151" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IconHideAmountNew = ({ width = 190, fill = "#000" }) => (
  <svg
    width={width}
    height="20"
    viewBox="0 0 190 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_772_30426)">
      <path
        d="M17.503 4.98127C17.0177 4.13811 15.9191 3.85748 15.076 4.34275L10.6325 6.92173V1.78868C10.6325 0.81845 9.84076 0.0263672 8.87053 0.0263672C7.90031 0.0263672 7.10822 0.81845 7.10822 1.78868V6.92173L2.66381 4.34275C1.82065 3.85748 0.723036 4.13811 0.238081 4.98127C-0.24847 5.82444 0.0334356 6.92173 0.8766 7.407L5.34623 10.0122L0.8766 12.6173C0.0334356 13.1023 -0.24847 14.2012 0.238081 15.044C0.723036 15.8872 1.82065 16.1678 2.66381 15.6825L7.10822 13.1023V18.2366C7.10822 19.2071 7.90031 19.9989 8.87053 19.9989C9.84076 19.9989 10.6325 19.2071 10.6325 18.2366V13.1023L15.076 15.6825C15.9191 16.1678 17.0177 15.8872 17.503 15.044C17.9883 14.2012 17.7076 13.1023 16.8645 12.6173L12.3948 10.0122L16.8645 7.407C17.7076 6.89683 18.0144 5.82444 17.503 4.98127Z"
        fill={fill}
      />
      <path
        d="M23.8228 15.0176C24.3081 15.8608 25.4054 16.1427 26.2486 15.6562L30.6933 13.0772V18.2102C30.6933 19.1817 31.485 19.9738 32.4553 19.9738C33.4255 19.9738 34.2176 19.1817 34.2176 18.2102V13.0772L38.6623 15.6562C39.5039 16.1427 40.6028 15.8608 41.0877 15.0176C41.573 14.1761 41.2924 13.0772 40.4492 12.5922L35.9796 9.98707L40.4492 7.38159C41.2924 6.89664 41.573 5.79807 41.0877 4.9549C40.6028 4.11174 39.5039 3.83111 38.6623 4.31639L34.2176 6.89664V1.76231C34.2176 0.792082 33.4255 0 32.4553 0C31.485 0 30.6933 0.792082 30.6933 1.76231V6.89664L26.2486 4.34257C25.4054 3.85729 24.3081 4.13792 23.8228 4.98108C23.3379 5.82425 23.6182 6.92154 24.4613 7.40682L28.931 10.012L24.4613 12.5922C23.6182 13.0772 23.3379 14.1761 23.8228 15.0176Z"
        fill={fill}
      />
      <path
        d="M47.3957 15.0176C47.8823 15.8608 48.9796 16.1427 49.8227 15.6562L54.2675 13.0772V18.2102C54.2675 19.1817 55.0579 19.9738 56.0294 19.9738C56.9997 19.9738 57.7918 19.1817 57.7918 18.2102V13.0772L62.2352 15.6562C63.0781 16.1427 64.1769 15.8608 64.6619 15.0176C65.1472 14.1761 64.8665 13.0772 64.0234 12.5922L59.5537 9.98707L64.0234 7.38159C64.8665 6.89664 65.1472 5.79807 64.6619 4.9549C64.1769 4.11174 63.0781 3.83111 62.2352 4.31639L57.7918 6.89664V1.76231C57.7918 0.792082 56.9997 0 56.0294 0C55.0579 0 54.2675 0.792082 54.2675 1.76231V6.89664L49.8227 4.31639C48.9796 3.83111 47.8823 4.11174 47.3957 4.9549C46.9108 5.79807 47.1927 6.89664 48.0342 7.38159L52.5039 9.98707L48.0342 12.5922C47.1927 13.0772 46.9108 14.1761 47.3957 15.0176Z"
        fill={fill}
      />
      <path
        d="M70.9814 15.0176C71.4666 15.8608 72.5639 16.1427 73.4071 15.6562L77.8518 13.0772V18.2102C77.8518 19.1817 78.6436 19.9738 79.6138 19.9738C80.5843 19.9738 81.3761 19.1817 81.3761 18.2102V13.0772L85.8208 15.6562C86.6627 16.1427 87.7613 15.8608 88.2466 15.0176C88.7315 14.1761 88.4509 13.0772 87.6081 12.5922L83.1384 9.98707L87.6081 7.38159C88.4509 6.89664 88.7315 5.79807 88.2466 4.9549C87.7613 4.11174 86.6627 3.83111 85.8208 4.31639L81.3761 6.89664V1.76231C81.3761 0.792082 80.5843 0 79.6138 0C78.6436 0 77.8518 0.792082 77.8518 1.76231V6.89664L73.4071 4.31639C72.5639 3.83111 71.4666 4.11174 70.9814 4.9549C70.4964 5.79807 70.777 6.89664 71.6199 7.38159L76.0895 9.98707L71.6199 12.5922C70.777 13.0772 70.4702 14.1761 70.9814 15.0176Z"
        fill={fill}
      />
      <path
        d="M94.5548 15.0308C95.04 15.874 96.1373 16.1559 96.9805 15.6693L101.425 13.0904V18.2234C101.425 19.1949 102.217 19.987 103.187 19.987C104.157 19.987 104.95 19.1949 104.95 18.2234V13.0904L109.394 15.6693C110.236 16.1559 111.335 15.874 111.82 15.0308C112.305 14.1893 112.024 13.0904 111.181 12.6054L106.712 10.0003L111.181 7.39478C112.024 6.90982 112.305 5.81125 111.82 4.96809C111.335 4.12492 110.236 3.8443 109.394 4.32957L104.95 6.90982V1.7755C104.95 0.805266 104.157 0.0131836 103.187 0.0131836C102.217 0.0131836 101.425 0.805266 101.425 1.7755V6.90982L96.9805 4.35575C96.1373 3.87047 95.04 4.1511 94.5548 4.99427C94.0698 5.83743 94.3501 6.93473 95.1933 7.42L99.6629 10.0252L95.1933 12.6054C94.3501 13.0904 94.0698 14.1893 94.5548 15.0308Z"
        fill={fill}
      />
      <path
        d="M118.128 15.0308C118.614 15.874 119.711 16.1559 120.555 15.6693L124.999 13.0904V18.2234C124.999 19.1949 125.79 19.987 126.761 19.987C127.732 19.987 128.524 19.1949 128.524 18.2234V13.0904L132.967 15.6693C133.81 16.1559 134.909 15.874 135.394 15.0308C135.879 14.1893 135.598 13.0904 134.755 12.6054L130.286 10.0003L134.755 7.39478C135.598 6.90982 135.879 5.81125 135.394 4.96809C134.909 4.12492 133.81 3.8443 132.967 4.32957L128.524 6.90982V1.7755C128.524 0.805266 127.732 0.0131836 126.761 0.0131836C125.79 0.0131836 124.999 0.805266 124.999 1.7755V6.90982L120.555 4.32957C119.711 3.8443 118.614 4.12492 118.128 4.96809C117.643 5.81125 117.925 6.90982 118.766 7.39478L123.236 10.0003L118.766 12.6054C117.925 13.0904 117.643 14.1893 118.128 15.0308Z"
        fill={fill}
      />
      <path
        d="M141.714 15.0308C142.199 15.874 143.296 16.1559 144.14 15.6693L148.584 13.0904V18.2234C148.584 19.1949 149.376 19.987 150.346 19.987C151.317 19.987 152.109 19.1949 152.109 18.2234V13.0904L156.553 15.6693C157.395 16.1559 158.494 15.874 158.979 15.0308C159.464 14.1893 159.183 13.0904 158.34 12.6054L153.871 10.0003L158.34 7.39478C159.183 6.90982 159.464 5.81125 158.979 4.96809C158.494 4.12492 157.395 3.8443 156.553 4.32957L152.109 6.90982V1.7755C152.109 0.805266 151.317 0.0131836 150.346 0.0131836C149.376 0.0131836 148.584 0.805266 148.584 1.7755V6.90982L144.14 4.32957C143.296 3.8443 142.199 4.12492 141.714 4.96809C141.229 5.81125 141.509 6.90982 142.352 7.39478L146.822 10.0003L142.352 12.6054C141.509 13.0904 141.203 14.1893 141.714 15.0308Z"
        fill={fill}
      />
      <path
        d="M165.287 15.044C165.772 15.8872 166.869 16.1691 167.712 15.6825L172.157 13.1035V18.2366C172.157 19.2081 172.949 20.0002 173.919 20.0002C174.889 20.0002 175.681 19.2081 175.681 18.2366V13.1035L180.126 15.6825C180.968 16.1691 182.067 15.8872 182.552 15.044C183.037 14.2024 182.756 13.1035 181.913 12.6186L177.443 10.0134L181.913 7.40796C182.756 6.92301 183.037 5.82444 182.552 4.98127C182.067 4.13811 180.968 3.85748 180.126 4.34275L175.681 6.92301V1.78868C175.681 0.81845 174.889 0.0263672 173.919 0.0263672C172.949 0.0263672 172.157 0.81845 172.157 1.78868V6.92301L167.712 4.36893C166.869 3.88366 165.772 4.16429 165.287 5.00745C164.802 5.85061 165.082 6.94791 165.925 7.43318L170.395 10.0383L165.925 12.6186C165.082 13.1035 164.802 14.2024 165.287 15.044Z"
        fill={fill}
      />
    </g>
  </svg>
);
export const ContainerTableMobile = styled.div`
  border-radius: 20px;
  background: #fff;
  padding: 12px;
`;
export const ContainerTableStakeMobile = styled.div`
  border-radius: 10px;
  background: #fff;
  padding: 16px;
  margin-bottom: 16px;
`;

export const TextValueTable1 = styled.div`
  color: #272729;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const TextValueTable2 = styled.div`
  color: #8c8d99;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const TagComponent = styled.div`
  padding: 2px 10px;
  border-radius: 38px;
  background: rgba(129, 129, 129, 0.1);

  color: #272729;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const LabelTable = styled.div`
  color: #272729;
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 29.5px; /* 92.188% */
  @media only screen and (max-width: 1024px) {
    color: #272729;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */
    text-transform: capitalize;
  }
`;

export const LabelTableViewAll = styled.div`
  color: #818181;
  text-align: right;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;

export const TextCellTable = styled.div`
  color: #000;
  text-align: right;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
`;
export const TextCellNormal = styled.div`
  min-width: ${props => props.minWidth ? props.minWidth : 'auto'};
  color: #000;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
`;

export const SlideBannerContainer = styled.div`
  position: relative;
  @media only screen and (max-width: 1024px) {
    &.showOver {
      &::before {
        content: "";
        position: absolute;
        pointer-events: none;
        z-index: 10;
        width: 81px;
        height: 90px;
        right: -25px;
        bottom: 5px;
        background: #F12E11;
      }
    }
  }
`;
export const EqualIconSmall =()=> (
  <svg
    width="10"
    height="7"
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_21310_17527)">
      <path
        d="M7.56049 2.53994C6.72017 2.53238 5.89378 2.34231 5.1481 1.98488C3.94605 1.39028 2.50104 1.39028 1.299 1.98488L0.811157 1.095C2.31943 0.355377 4.12766 0.355377 5.63594 1.095C6.83798 1.6896 8.283 1.6896 9.48504 1.095L9.97288 1.98488C9.2272 2.34231 8.4008 2.53238 7.56049 2.53994Z"
        fill="#8C8D99"
      />
      <path
        d="M7.56049 6.53994C6.72017 6.53238 5.89378 6.34231 5.1481 5.98488C3.94605 5.39028 2.50104 5.39028 1.299 5.98488L0.811157 5.095C2.31943 4.35538 4.12766 4.35538 5.63594 5.095C6.83798 5.6896 8.283 5.6896 9.48504 5.095L9.97288 5.98488C9.2272 6.34231 8.4008 6.53238 7.56049 6.53994Z"
        fill="#8C8D99"
      />
    </g>
    <defs>
      <clipPath id="clip0_21310_17527">
        <rect
          width="9.216"
          height="6"
          fill="white"
          transform="translate(0.784058 0.540039)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const FilterRowItem = styled.div`
  width: calc(25% - 20px);

  @media screen and (max-width: 1024px) {
    & {
      width: 100%;
    }

    & .ant-form-item-row {
      display: flex !important;
      flex-wrap: nowrap !important;
      align-items: center !important;
      justify-content: flex-start !important;
    }

    & .ant-form-item .ant-form-item-label {
      display: inline-flex !important;
      flex: none !important;
      padding: 0 !important;
      width: 100px !important;
      margin-right: 6px !important;
    }

    & .ant-form-item .ant-form-item-control {
      flex: 1 !important;
    }

    & .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
      height: 40px !important;
      padding-left: 18px !important;
    }

    & .ant-select-single .ant-select-selector .ant-select-selection-item,
    &.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
      line-height: 40px !important;
    }
  }
`;

export const FilterRowItemMb = styled.div`
  width: calc(100% - 5px);
`;

export const FilterRowItemPairMb = styled.div`
  width: calc(100% - 5px);
  display: flex;
  
`;

export const FormPairItem = styled(Form.Item)`
  & .ant-form-item-row {
    display: block;
  }
  & label {
    font-weight: 400;
    font-size: 15px;
    line-height: 25px;
    color: #818181;

    &::after {
      display: none;
    }
  }
  .ant-form-item-control-input-content{
    display: flex;
    gap: 10px;

    >div {
      width: 50%;
    }
  }
`;